enum StatusEnum {
    NOT_STARTED = 1,
    PARTIAL = 2,
    COMPLETED = 3,
}

export default StatusEnum;
